import { FunctionComponent, PropsWithChildren, useEffect, useState } from 'react';
import styles from './Spinner.module.css';

type DelayedSpinnerProps = PropsWithChildren<{
  delay?: number;
  enabled?: boolean;
}>;

export const DelayedSpinner: FunctionComponent<DelayedSpinnerProps> = ({
  children,
  delay = 200,
  enabled = true,
}) => {
  const [elapsed, setElapsed] = useState(false);

  useEffect(() => {
    if (!enabled) {
      return setElapsed(false);
    }
    const timeout = setTimeout(() => setElapsed(true), delay);
    return () => clearTimeout(timeout);
  }, [delay, enabled]);

  return elapsed ? <Spinner /> : <>{children}</> || null;
};

export function Spinner() {
  return (
    <div className={styles.spinner}>
      <div className={styles.bounce1} />
      <div className={styles.bounce2} />
      <div className={styles.bounce3} />
    </div>
  );
}
